import React, { useEffect, useState, useCallback } from 'react';
import { Prompt } from 'react-router-dom';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import { COLOR } from '@src/styles/color';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const StyledActions = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  padding: 0px 24px;

  .btn-action {
    text-transform: none;
    height: 40px;
    border-radius: 8px;
  }
`;

const NavigationBlocker = ({
  when,
  navigate,
  title,
  description,
  cancelText,
  confirmText,
  onLeave,
}) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      if (!confirmedNavigation) {
        setModalVisible(true);
        setLastLocation(nextLocation);
        return false;
      }
      return true;
    },
    [confirmedNavigation],
  );

  const handleStay = useCallback(() => {
    setModalVisible(false);
  }, []);

  const handleLeave = useCallback(() => {
    if (onLeave) onLeave();
    setModalVisible(false);
    setConfirmedNavigation(true);
  }, [onLeave]);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.pathname);
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation, navigate]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <NotificationDialogV3
        name="navigation-blocker"
        open={modalVisible}
        maxWidth="512px"
        variant="none"
        title={title || t('note')}
        padding="12px 24px"
        renderIcon={() => (
          <WarningRoundedIcon sx={{ fontSize: 24, color: COLOR.alert }} />
        )}
        paddingHeader="8px 24px"
        description={description}
        onClose={handleStay}
        actionComponent={
          <StyledActions>
            <Button
              className="btn-action"
              variant="outlined"
              onClick={handleStay}
            >
              {cancelText || t('cancel')}
            </Button>
            <Button
              className="btn-action"
              variant="contained"
              onClick={handleLeave}
            >
              {confirmText || t('exitPage')}
            </Button>
          </StyledActions>
        }
      />
    </>
  );
};

export default NavigationBlocker;
